import React from 'react';
import { observer } from 'mobx-react-lite';
import { MoreIconCMS } from 'src/assets/MoreIconCMS';
import { ClickOutsideHandler } from 'src/domains/common/components/clickOutside';
import { DropdownMenuState } from 'src/components/GlobalPageV2/DropdownMenu/DropdownMenu.state';
import { Switch } from 'src/domains/common/components/switch/switch';
import { DropdownItemType } from './ListItem';

interface PropsType {
    title: string;
    active?: boolean;
    switchOnChange?: () => Promise<void>;
    dropdownState: DropdownMenuState;
    dropdownItemsForView: DropdownItemType[];
}

export const ListItemComponent = observer((props: PropsType): JSX.Element => {
    const { title, active, switchOnChange, dropdownState, dropdownItemsForView } = props;

    return (
        <div className='font-tertiary flex justify-between items-center border-solid border-t-0 border-l-0 border-r-0 border-border py-3 px-2'>
            <div className='text-foreground text-sm'>{title}</div>

            <div className='flex'>
                {active === undefined ? null : (
                    <>
                        <div className='text-foreground text-sm'>{active ? 'Published' : 'Unpublished'}</div>

                        <Switch
                            labelPosition='left'
                            checked={active}
                            onChange={switchOnChange}
                        ></Switch>
                    </>
                )}

                <ClickOutsideHandler onClickOutside={dropdownState.closeDropdownMenu}>
                    <MoreIconCMS
                        className='cursor-pointer ml-3'
                        onClick={dropdownState.toggleDropdownMenu}
                    />

                    {dropdownState.isOpen && (
                        <div className='rounded-md shadow bg-white border border-border border-solid absolute right-0 p-1 mx-1 my-2 w-[128px] z-50'>
                            {dropdownItemsForView.map(({ label, onClick }) => (
                                <div
                                    className='px-2 py-[6px] text-foreground cursor-pointer text-left hover:bg-accent'
                                    key={label}
                                    onClick={onClick}
                                >
                                    {label}
                                </div>
                            ))}
                        </div>
                    )}
                </ClickOutsideHandler>
            </div>
        </div>
    );
});
